<div class="separator-content mx-auto">
  <div class="intro-icon mb-4">
    @switch (type) {
      @case ('Link_slide') {
        @if (url) {
          <a [href]="url" target="_blank" rel="noopener noreferrer" (click)="onButtonClick()">
            <ng-template [ngTemplateOutlet]="linkIcons"></ng-template>
          </a>
        }
        @if (!url && dialogButton) {
          <a [routerLink]="undefined" (click)="onButtonClick()">
            <ng-template [ngTemplateOutlet]="linkIcons"></ng-template>
          </a>
        }
        @if (!url && skipLink && !dialogButton) {
          <a [routerLink]="skipLink">
            <ng-template [ngTemplateOutlet]="linkIcons"></ng-template>
          </a>
        }
        <ng-template #linkIcons>
          <mat-icon svgIcon="separator_link_v2"></mat-icon>
        </ng-template>
      }
      @case ('Video_slide') {
        <mat-icon
          [svgIcon]="(specialSlide === 'anekdote') ? 'separator_anecdote_v2' : 'separator_video_v2'"
          (click)="onButtonClick()">
        </mat-icon>
      }
      @case ('Quiz_slide') {
        <mat-icon svgIcon="separator_nextgen_quiz_v2" (click)="onButtonClick()"></mat-icon>
      }
      @case ('Certificate_slide') {
        <mat-icon svgIcon="separator_certificate_v2" (click)="onButtonClick()"></mat-icon>
      }
      @case ('User_training_rating_slide') {
        <mat-icon svgIcon="separator_feedback_v2" (click)="onButtonClick()"></mat-icon>
      }
      @case ('Interactive_content_slide') {
        @switch (specialSlide) {
          @case ('quiz') {
            <mat-icon svgIcon="separator_nextgen_quiz_v2" (click)="onButtonClick()"></mat-icon>
          }
          @default {
            <mat-icon svgIcon="separator_interactive_v2" (click)="onButtonClick()"></mat-icon>
          }
        }
      }
      @case ('Passive_content_slide') {
        @switch (specialSlide) {
          @case ('handbook') {
            <mat-icon svgIcon="separator_protocol_v2" (click)="onButtonClick()"></mat-icon>
          }
          @default {
            <mat-icon svgIcon="separator_link_v2" (click)="onButtonClick()"></mat-icon>
          }
        }
      }
    }
  </div>

  @if (title) {
    <h1 class="mb-2">
      <span>{{title}}</span>
    </h1>
  }

  @if (!loading) {
    <div>
      @switch (type) {
        @case ('Video_slide') {
          <span [innerHTML]="introText | prismicHtml"></span>
        }
        @case ('Interactive_content_slide') {
          <span [innerHTML]="introText | prismicHtml"></span>
        }
        @case ('Quiz_slide') {
          @if (introText) {
            <span [innerHTML]="introText"></span>
          }
          @if (!introText) {
            <span [innerHTML]="'INTRO_SLIDE.TEXT.QUIZ' | translate"></span>
          }
        }
        @default {
          <span [innerHTML]="introText"></span>
        }
      }
    </div>
    <div class="cta-container container mt-5">
      <div class="row">
        @if (url) {
          <a
            mat-raised-button
            class="primary-cta col-12"
            [href]="url"
            target="_blank"
            (click)="onButtonClick()"
            rel="noopener noreferrer">
            <span>{{buttonText}}</span>
          </a>
        }
        @if (!url && buttonText) {
          <button class="primary-cta col-12" mat-raised-button (click)="onButtonClick()">
            <span>{{buttonText}}</span>
          </button>
        }
      </div>
      <div class="row justify-content-between mt-4 bottom-row">
        @if (backLink) {
          <a class="back-link col-12 order-last order-sm-first col-sm" mat-stroked-button [routerLink]="backLink">
            <span translate>INTRO_SLIDE.BACK</span>
          </a>
        }
        @if (buttonText && skipLink) {
          <a
            class="skip-link col-12 order-first order-sm-last mb-2 mb-sm-0 col-sm"
            mat-stroked-button
            [routerLink]="skipLink">
            <!-- there might be cases where we want to show custom text instead of 'skip' for a specific slide -->
            <span>{{skipText ? skipText : 'INTRO_SLIDE.SKIP' | translate}}</span>
          </a>
        }
        <!-- This button is used for intro slides and slides where there is no interaction left -->
        @if (!buttonText && skipLink) {
          <a
            class="primary-cta col-12 col-sm order-first order-sm-last mb-4 mb-sm-0"
            mat-raised-button
            [routerLink]="skipLink">
            <span>{{skipText ? skipText : 'INTRO_SLIDE.SKIP' | translate}}</span>
          </a>
        }
      </div>
    </div>
  }

  @if (loading) {
    <img class="troodi-spinner" src="assets/img/troodi_spinner.gif" />
  }
</div>
